<script>
  import Button from "../../../components/button/Button.svelte";

  export let onClickNext

  export let onClickBack
</script>

<div class="step-root">
  <div style="display: flex">
    {#if onClickBack}
      <div style="margin-right: auto;">
        <Button size="large" onClick={onClickBack} type="secondary">
          ← 戻る
        </Button>
      </div>
    {/if}
    {#if onClickNext}
      <div style="margin-left: auto;">
        <Button size="large" onClick={onClickNext} type="secondary">
          次へ →
        </Button>
      </div>
    {/if}
  </div>
  <div>
    <slot />
  </div>
</div>

<style>
  .step-root {
    padding: 2rem;
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }
</style>
